import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import VueCookies from "vue-cookies";
import VueMoment from "vue-moment";
import VueTrumbowyg from "vue-trumbowyg";
import VueClipboard from "vue-clipboard2";
import DialogImage from "./components/main/dialog/DialogImage";
import TransitionObj from "./components/main/Transition";
import VueMask from "v-mask";
import Axios from "axios";

import "@/mixins/mixin";
import "../src/styles/app.scss";
import "trumbowyg/dist/ui/trumbowyg.css";

import "@/styles/colors.scss";
import "@/styles/index.scss";
import "@/styles/button.scss";
import "@/styles/dialog.scss";
import "@/styles/menu.scss";



Vue.config.productionTip = false;
Vue.prototype.$axios = Axios;
// Vue.component('vue-cropper',VueCropper);
Vue.component("DialogImage", DialogImage);
Vue.component("TransitionObj", TransitionObj);
Vue.use(VueCookies);
Vue.use(VueMoment);
Vue.use(VueTrumbowyg);
Vue.use(VueMask);


VueClipboard.config.autoSetContainer = true;
Vue.use(VueClipboard);

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
